import Loader from 'components/_UI/Loader'
import DetailVisibleProvider from 'context/dash/DetailVisible'
import ListProductsProvider from 'context/products/ListProducts'
import UserProvider from 'context/user/User'
import DashContainer from 'modules/dashboard/_common/DashContainer'
import MainContent from 'modules/dashboard/resume/MainContent'
import React from 'react'

export default function DashResume() {
 
  return (
    <DetailVisibleProvider>
      <UserProvider>
        <ListProductsProvider>
          <DashContainer title={`Bem vindo!`}>
            <MainContent />
          </DashContainer>
        </ListProductsProvider>
      </UserProvider>
    </DetailVisibleProvider>
  )
}
